import Component from "gia/Component";
import Ukiyo from "ukiyojs";
import Env from "../base/env";
import gsap from "gsap";
import { getViewport } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.VARS = {
      TRIGGER: false,
    };

    // gsap.set(this.DOM.view, { autoAlpha: 0 });
    this.call();
    this.observe();
  }

  create() {
    if (Env.mobileCSS == false) {
      const scale =
        typeof this.DOM.view.getAttribute("data-parallax-scale") != "undefined"
          ? this.DOM.view.getAttribute("data-parallax-scale") * 1
          : 1.2;
      const speed = this.DOM.view.getAttribute("data-parallax-speed")
        ? this.DOM.view.getAttribute("data-parallax-speed") * 1
        : 1.1;

      gsap.delayedCall(0.2, () => {
        this.parallax = new Ukiyo(this.DOM.view, {
          scale: scale, // 1~2 is recommended
          speed: speed, // 1~2 is recommended
          willChange: true, // This may not be valid in all cases
        });
      });
      gsap.delayedCall(0.3, () => {
        gsap.set(this.DOM.view, {
          autoAlpha: 1,
          ease: "linear",
          duration: 0.15,
        });
      });
    }
  }

  call() {
    this.VARS.TRIGGER = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this.DOM.view);

      this.create();
    };
  }

  observe() {
    const viewport = getViewport();
    const observer = new IntersectionObserver(this.VARS.TRIGGER, {
      rootMargin: `0px 0px ${viewport.height * 2.5}px 0px`,
    });

    observer.observe(this.DOM.view);
  }

  unmount() {
    if (typeof this.parallax != "undefined") {
      this.parallax.destroy();
    }
  }
}
